import React from "react";
import {sanitizeHtml} from "../sanitizeHtml/sanitizeHtml";
import classNames from "classnames";
import "./TextEditorReader.scss"

const TextEditorReader = ({text, className}) => {
    return(
        <div className={classNames("text-editor-reader", className)}>
            <div dangerouslySetInnerHTML={{__html: sanitizeHtml(text)}} />
        </div>
    )
}

export default TextEditorReader;